/* Pikmoto — Lenticular Preview (auto-mount + API)
   Listens: document 'lenti:set-images' {a,b}, 'lenti:set-aspect' {aspect}
   Creates: <div class="lenti-root"><div class="lenti-box"><div class="lenti-card">...</div></div></div>
*/
(function(){


  function create(mount, opts) {
    opts = opts || {};
    var aspect = (opts.aspect || "4:5").split(":").map(Number);
    var tilt = typeof opts.tiltDeg === "number" ? opts.tiltDeg : -18;

    var root = document.createElement("div");
    root.className = "lenti-root";

    var box = document.createElement("div");
    box.className = "lenti-box";
    root.appendChild(box);
    mount.appendChild(root);

    var card = document.createElement("div");
    card.className = "lenti-card";
    card.style.setProperty("--tiltB", "rotateY(" + tilt + "deg)");

    // Frame Texture Wrapper
    var frameWrap = document.createElement("div");
    frameWrap.className = "lenti-frame-wrap";
    var frameTexture = document.createElement("div");
    frameTexture.className = "lenti-frame-texture";
    frameWrap.appendChild(frameTexture);

    var frame = document.createElement("div");
    frame.className = "lenti-frame";

    var a = document.createElement("img");
    a.className = "lenti-img a";
    a.alt = "";
    a.decoding = "async";
    a.loading = "lazy";
    a.src = opts.imgA || "";

    var b = document.createElement("img");
    b.className = "lenti-img b";
    b.alt = "";
    b.decoding = "async";
    b.loading = "lazy";
    b.src = opts.imgB || opts.imgA || "";

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "lenti-flip";
    btn.setAttribute("aria-pressed", "false");
    btn.setAttribute("aria-label", "Toggle image and tilt");
    btn.textContent = 'View Motion';

    // Composition
    frame.appendChild(a);
    frame.appendChild(b);
    card.appendChild(frameWrap); 
    card.appendChild(frame);
    card.appendChild(btn);
    box.appendChild(card);
    // ADD THIS LINE: This allows the external applyFrame function 
    // to find the element it needs to toggle.
    card.setAttribute('data-lenti-full-preview', '');

    var isB = false;
    function toggle() {
      isB = !isB;
      card.classList.toggle("is-b", isB);
      btn.setAttribute("aria-pressed", String(isB));
    }

    btn.addEventListener("click", toggle);
    frame.addEventListener("click", toggle);

    function size() {
      // Constraints: 450px Desktop, 250px Mobile
      var MAX = (window.matchMedia && window.matchMedia("(max-width: 480px)").matches) ? 250 : 450,
          rw = aspect[0] || 4, 
          rh = aspect[1] || 5, 
          w = Math.min(MAX, box.clientWidth || MAX), 
          h = w * (rh / rw);
      
      if (h > MAX) { 
        h = MAX; 
        w = h * (rw / rh); 
      }
      
      card.style.width = Math.round(w) + "px";
      card.style.height = Math.round(h) + "px";
    }

    function setAspect(str) {
      var p = (str || "").split(":").map(Number);
      if (p[0] > 0 && p[1] > 0) {
        aspect = p;
        size();
      }
    }

    function setImages(d) {
      if (d && d.a) { a.src = d.a; }
      if (d && d.b) { b.src = d.b; }
      if (d && d.a && !d.b) { b.src = d.a; }
    }

    window.addEventListener("resize", size);
    size();

    return {
      setAspect: setAspect,
      setImages: setImages,
      toggle: toggle,
      // Add this new function
      setFrame: function(frameValue) {
        const FRAME_CLASSES = ['ltc-white', 'ltc-black', 'ltc-oak'];
        // Remove old
        FRAME_CLASSES.forEach(c => card.classList.remove(c));
        card.classList.remove('frame-on');
        
        // Add new
        if (frameValue) {
          card.classList.add('ltc-' + frameValue);
          card.classList.add('frame-on');
        }
      },
      setOrient: function(isH) {
        card.setAttribute('data-orient', isH ? 'h' : 'v');
      }
    };
  }

  function bind(instance, scope) {
    document.addEventListener("lenti:set-aspect", function(e) {
      if (e.detail && e.detail.aspect) {
        instance.setAspect(e.detail.aspect);
        // Also update orientation for the texture rotation
        var dims = e.detail.aspect.split(':').map(Number);
        instance.setOrient(dims[0] > dims[1]);
      }
    });
    document.addEventListener("lenti:set-images", function(e) {
      instance.setImages(e.detail || {});
    });
    // ADD THIS: Listen for frame changes
    document.addEventListener("lenti:set-frame", function(e) {
       instance.setFrame(e.detail.frame);
    });
  }

  var API = {
    mount: function(el, opts) {
      var inst = create(el, opts || {});
      bind(inst, document);
      return inst;
    },
    auto: function(scope) {
      var root = scope || document, nodes = root.querySelectorAll("[data-lenti-preview]");
      if (!nodes.length) {
        var form = root.querySelector('form[action*="/cart/add"]') || root.querySelector("product-form form");
        if (form) {
          var holder = document.createElement("div");
          holder.setAttribute("data-lenti-preview", "");
          form.parentNode.insertBefore(holder, form.nextSibling);
          nodes = [holder];
        }
      }
      nodes.forEach(function(n) {
        var opts = {};
        var host = n.closest('[data-lenti-root]');
        if (host && host.getAttribute('data-ratio')) {
          opts.aspect = host.getAttribute('data-ratio');
        }
        API.mount(n, opts);
      });
    }
  };

  if (!window.PikmotoPreview) window.PikmotoPreview = API;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() { API.auto(document); initFrameDetails(document); });
  } else {
    API.auto(document); initFrameDetails(document);
  }

  function initFrameDetails(scope) {
    var root = scope || document;
    var buttons = root.querySelectorAll(".frame-color");
    var modals = root.querySelectorAll(".frame-details-modal");
    if (!buttons.length || !modals.length) return;

    modals.forEach(function(m) { m.classList.remove("is-open"); m.setAttribute("aria-hidden", "true"); });
    buttons.forEach(function(b) { b.classList.remove("is-active"); });

    function closeAll() {
      modals.forEach(function(m) { m.classList.remove("is-open"); m.setAttribute("aria-hidden", "true"); });
      buttons.forEach(function(b) { b.classList.remove("is-active"); });
    }

    root.addEventListener("click", function(e) {
      var btn = e.target.closest(".frame-color");
      if (!btn) return;
      var color = btn.dataset.lentiFrame;
      if (!color) return;
      var target = root.querySelector(".frame-details-modal-" + color);
      if (!target) return;
      var already = target.classList.contains("is-open");
      closeAll();
      if (!already) {
        target.classList.add("is-open");
        target.setAttribute("aria-hidden", "false");
        btn.classList.add("is-active");
      }
    });
  }
})();